import { render, staticRenderFns } from "./shuidianPrivacy.vue?vue&type=template&id=41be147a&scoped=true"
import script from "./shuidianPrivacy.vue?vue&type=script&lang=js"
export * from "./shuidianPrivacy.vue?vue&type=script&lang=js"
import style0 from "./shuidianPrivacy.vue?vue&type=style&index=0&id=41be147a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be147a",
  null
  
)

export default component.exports